import { AxiosError, AxiosResponse } from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import { DropdownToggle, Spinner } from "reactstrap";
import { Dropdown } from "reactstrap";
// import { BankUserContext } from '../../bankUserContext';
// import SpinnerModel from '../../commonFields/SpinnerModel';
// import { TodoModel } from '../../Models/NotificationsModel/NotificationModel'
// import CustomerService from '../../Services/CustomerService';
// import { APP_Config } from '../../Utils/App_configUtil';
// import RolesAuthentication from '../../Utils/RolesUtlis';
// import { catchError } from '../../Utils/Utils';
import { ReactComponent as CombinedShape } from "../../../images/CombinedShape.svg";
import { DropdownMenu, DropdownItem } from "reactstrap";
import { Nav, Tab } from "react-bootstrap";
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
// import AssignTodoForm from './AssignTodoForm';
// import TodoViewDetails, { TodoStatus } from './ManualTodos/TodoViewDetails';
import { Button } from "reactstrap";
// import CreateTodoForm from './ManualTodos/CreateTodoForm';
import { ReactComponent as ManualIcon } from "../../../images/manual-icon.svg";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { TodoModel } from "../../../models/TodoModel";
import { catchError } from "../../../utils/Utils";
import { APP_Config } from "../../../utils/AppConfig";
import CreateTodoForm from "./ManualTodos/CreateTodoForm";
import TodoViewDetails, { TodoStatus } from "./ManualTodos/TodoViewDetails";
import {
  formatDateOrDay,
  getCompanyLocationNames,
  valueEllipsis,
} from "../../../utils/GeneralUtils";
import AssignTodoForm from "./AssignTodoForm";
import SpinnerModel from "../../../commonfields/SpinnerModel";
import FinSpinner from "../../../commonfields/FinSpinner";
import RoleAuthorization from "../../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../../utils/RolesUtil";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import {
  RoleAuthorizationCC,
  withContext,
} from "../../Authentication/RoleAuthorizationClassComponent";
import { Link } from "react-router-dom";
import EllipsisTooltip from "../../../utils/EllipsisTooltip";

// import { getCompanyLocationNames } from '../../Utils/GeneralUtils';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITodoRCProps {
  interactionData: String[];
}

interface ITodoRCState {
  init: boolean;
  todoToggle: string;
  todoData: TodoModel[] | [];
  todoFilter: TodoModel[] | [];
  loader: boolean;
  interval: any;
  assignTodoModal: boolean;
  selectedTodo: TodoModel | null;
  createTodoModal: boolean;
  todoViewDetailsModal: boolean;
  todoViewLoader: boolean;
  reloadComponent: boolean;
  firstUpdate: boolean;
  todoSearch: string;
  redirectUrl: string;
}

class TodoRC extends Component<WithRouterProps<ITodoRCProps>, ITodoRCState> {
  service = new Service();
  // roles = new RolesAuthentication();
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;

  constructor(props: WithRouterProps<ITodoRCProps>) {
    super(props);
    this.state = {
      init: true,
      todoToggle: "-1",
      todoData: [],
      todoFilter: [],
      loader: false,
      interval: null,
      assignTodoModal: false,
      selectedTodo: null,
      createTodoModal: false,
      todoViewDetailsModal: false,
      todoViewLoader: false,
      reloadComponent: false,
      firstUpdate: false,
      todoSearch: "",
      redirectUrl: "",
    };
  }

  // toggle todo dropdown for each in list
  setIsOpen = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, index: string) => {
    event.preventDefault()
    event.stopPropagation();
    this.setState({
      todoToggle: index === this.state.todoToggle ? "-1" : index,
    });
  };

  // toggle todo assignment modal
  toggle = () => {
    this.setState({ assignTodoModal: !this.state.assignTodoModal });
  };

  TooltipWrapper = (content: string = "") => {
    return (
      <div className="lable tooltip-container">
        <span className="title">
          {content.length > 20 ? content.substring(0, 20) + "..." : content}
        </span>
      </div>
    );
  };

  // set selected todo
  setSelectedTodo = (value: TodoModel | null) =>
    this.setState({ selectedTodo: value });

  createTodoToggle = () =>
    this.setState({ createTodoModal: !this.state.createTodoModal });

  toggleViewDetails = () =>
    this.setState({ todoViewDetailsModal: !this.state.todoViewDetailsModal });

  reloadComponent = () =>
    this.setState({ reloadComponent: !this.state.reloadComponent });

  toggleTodoViewLoader = (value?: boolean) =>
    this.setState({
      todoViewLoader: value ?? !this.state.todoViewLoader,
    });

  // get todo list
  getTodo = () => {
    let data: any = {
      screen: "LandingPage",
      sections: "GetTodos",
      isJsonReturnObject: false,
    };
    if (this.context?.bankuserDetails) {
      data = {
        ...data,
        userId: this.context?.bankuserDetails.userId,
      };
    }
    if (
      this.props.interactionData.length > 0 &&
      this.context?.bankuserDetails
    ) {
      // for filtering only action items todos
      data = {
        screen: "LandingPage",
        sections: "GetTodos",
        todoTypeId: 3,
        interactionId: this.props.interactionData,
        userId: this.context?.bankuserDetails.userId,
        isJsonReturnObject: false,
      };
    }
    this.setState({ loader: true });
    this.service
      .getTodoListByUserId(data)
      .then((res: AxiosResponse<TodoModel[]>) => {
        this.setState({ todoData: res?.data || [] });
      })
      .catch((err) => catchError(err, true))
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  updateTodo = (data: any) => {
    return this.service.updateTodo(data);
  };

  // flag and unflag todo, pass true to flag
  todoFlagged = (element: TodoModel | null, priority: number) => {

    if (element) {
      if (!element.isManual) {
        const data = {
          sections: "updateTodo",
          todoUuid: element.todoUuid,
          priority: priority,
          status: element.status,
          assignedTo: this.context?.bankuserDetails?.userId,
        };

        this.updateTodo(data)
          .then((response: AxiosResponse<string>) => {
            toast.success(
              `${priority === 2 ? "Todo Flagged" : "Todo Unflagged"}`,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            this.getTodo();
            this.reloadComponent();
          })
          .catch((err: AxiosError) => catchError(err, true))
          .finally(() => this.setState({ loader: false }));
      }

      if (element.isManual) {
        const data = {
          sections: "updateTodo",
          todoUuid: element.todoUuid,
          isManual: true,
          priority: priority,
          status: element.status,
          assignedTo: element.assigned,
        };
        this.service
          .updateManualTodo(data)
          .then(() => {
            toast.success(
              `${priority === 2 ? "Todo Flagged" : "Todo Unflagged"}`,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            this.getTodo();
            this.reloadComponent();
          })
          .catch((err: AxiosError) => catchError(err, true))
          .finally(() => this.setState({ loader: false }));
      }
    }

  };

  toggleTodoFlag = (element: TodoModel) => {
    if (element.priority === 2) {
      this.todoFlagged(element, 3);
    } else {
      this.todoFlagged(element, 2);
    }
  };

  markTodoComplete = (element: TodoModel, status: string) => {

    this.getTodo();
    this.reloadComponent();
    this.handleStatusChange(element, TodoStatus.Completed, true);
  };

  handleStatusChange = (
    todo: TodoModel,
    status: string,
    reloadSingle = false
  ) => {
    if (todo.referenceId) {
      this.service
        .todoStatusChange(todo.referenceId, status)
        .then((response: AxiosResponse<string>) => {
          toast.success(response.data);
          this.getTodo();
          reloadSingle && this.toggleViewDetails();
          this.reloadComponent();
        })
        .catch((err: AxiosError) => catchError(err, true));
    }

    if (todo.isManual) {
      const data = {
        sections: "updateTodo",
        todoUuid: todo.todoUuid,
        isManual: true,
        priority: todo.priority,
        status: status,
        assignedTo: todo.assigned,
      };
      this.service
        .updateManualTodo(data)
        .then((response: AxiosResponse<any>) => {
          toast.success("Manual Todo Updated");
          this.getTodo();
          reloadSingle && this.toggleViewDetails();
          this.reloadComponent();
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });
    }
  };

  // Todo Redirect
  todoRedirest = (element: any) => {
    console.log(element)
    const url = `/${element?.redirectUrl}/${element?.clientId}/${element.clientProductsId}`
    if (
      element.status.toLowerCase() === "open" &&
      withContext(
        this.context,
        Pages.landingPage,
        actionAuthorization.editMyTodos
      )
    ) {
      const data = {
        sections: "updateTodo",
        todoUuid: element.todoUuid,
        priority: element.priority,
        status: "In_Progress",
        assignedTo: this.context?.bankuserDetails?.userId,
      };
      this.setState({ loader: true });
      this.updateTodo(data)
        .then((response: AxiosResponse<string>) => {
          this.getTodo();
          if (element.todoTypeId === 3 || element.todoTypeId === 1) {
            localStorage.setItem('clientActionId', element.clientActionId);
          }
          else {
            this.reloadComponent();
            this.props?.navigate(url)
          }


        })
        .catch((err: AxiosError) => catchError(err, true))
        .finally(() => this.setState({ loader: false }));
    }
    else {
      if (element.todoTypeId === 3 || element.todoTypeId === 1) {
        localStorage.setItem('clientActionId', element.clientActionId);
      }
      else {
        this.props?.navigate(url)
      }
    }
  };

  // leadDetails = (element: TodoModel) => {
  //   const role = this.context?.bankuserDetails?.roles;
  //  if(element.shortCode.toLowerCase()=="ld"){
  //   window.open(`leadTracker/details/${element.clientUuid}`);
  //  }else if(element.shortCode.toLowerCase()=="op"){
  //    if(this.roles.isComplianceUser(role) || this.roles.isPrevetWriterUser(role)){
  //     window.open(`underwritingTracker/details/${element.clientUuid}`);
  //    }else{
  //     window.open(`opportuntiestracker/details/${element.clientUuid}`)
  //    }
  //  }else if(element.shortCode.toLowerCase()=="rl"){
  //   window.open(`/RelationshipsTracker/details/${element.clientUuid}`)
  //  }else{
  //   toast.error("NO ACCESS TO CLIENT");
  //  }
  // };

  handleViewDetails = (element: TodoModel) => {
    if (
      element?.status === TodoStatus.Open &&
      element.todoTypeId !== 5 &&
      element.todoTypeId !== 2
    ) {
      this.getTodo();

      this.setSelectedTodo(element);
      this.handleStatusChange(element, TodoStatus.In_Progress, true);
      this.toggleViewDetails();
    }
    else if (element?.status === TodoStatus.Open && element?.todoTypeId === 2) {
      const modifiedElement = {
        ...element,
        status: TodoStatus.In_Progress,
      }
      this.getTodo();
      this.setSelectedTodo(modifiedElement);
      this.handleStatusChange(element, TodoStatus.In_Progress, false);
      this.toggleViewDetails();
    }
    else {
      this.getTodo();

      this.setSelectedTodo(element);
      this.toggleViewDetails();
    }
  };

  onClickTodo = async (element: TodoModel, event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // event.preventDefault()
    if (element.todoTypeId === 5 || element.todoTypeId === 2) {
      this.handleViewDetails(element);
    } else if (element?.clientId) {
      await this.todoRedirest(element);
    }
  };

  componentDidMount() {
    const time =
      APP_Config().REACT_APP_RELOAD_TIME !== undefined
        ? parseInt(APP_Config().REACT_APP_RELOAD_TIME) * 60 * 1000
        : 0;
    this.getTodo();
    // this.setState({
    //   interval: setInterval(() => this.getTodo(), time)
    // })
  }

  componentWillUnmount(): void {
    clearInterval(this.state.interval);
  }

  componentDidUpdate(
    prevProps: Readonly<ITodoRCProps>,
    prevState: Readonly<ITodoRCState>,
    snapshot?: any
  ): void {
    if (this.props.interactionData !== prevProps.interactionData) {
      this.getTodo();
    }
  }

  serachTodo = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ todoSearch: e?.target?.value || "" });
    if (e.target.value !== "") {
      const list = this.state.todoData?.filter((element: TodoModel) => {
        return (
          element?.todoDescription
            ?.toLowerCase()
            ?.match(e?.target?.value?.toLowerCase()) ||
          element?.businessName
            ?.toLowerCase()
            ?.match(e?.target?.value?.toLowerCase())
        );
      });
      this.setState({ todoFilter: list || [] });
    } else {
      this.setState({ todoFilter: [] });
    }
  };

  getTodoData = (tabValue: string) => {
    if (tabValue === "open") {
      return (
        this.state.todoFilter && this.state.todoSearch
          ? this.state.todoFilter
          : this.state.todoData
      )?.filter(
        (each) =>
          each.status !== TodoStatus.In_Progress &&
          each.status !== TodoStatus.Completed
      );
    } else if (tabValue === "inProgress") {
      return (
        this.state.todoFilter && this.state.todoSearch
          ? this.state.todoFilter
          : this.state.todoData
      )?.filter((each) => each.status === TodoStatus.In_Progress);
    } else if (tabValue === "unAssigned") {
      return (
        this.state.todoFilter && this.state.todoSearch
          ? this.state.todoFilter
          : this.state.todoData
      )?.filter((each) => !each?.assigned);
    } else {
      return [];
    }
  };

  getTodoElement = (data: TodoModel[] | undefined) => {
    // const rolesAuth=RoleAuthorization(Pages.landingPage , actionAuthorization.editMyTodos);
    // console.log(data)
    return (
      <>
        {this.state.loader ? <FinSpinner /> : null}

        {data !== undefined && data?.length > 0 ? (
          data
            .sort((a: TodoModel, b: TodoModel) => a.priority - b.priority)
            ?.map((element: any, index) => (
              (element.todoTypeId === 3 || element.todoTypeId === 1) ? (<Link
                to={`/${element?.redirectUrl}/${element?.clientId}/${element.clientProductsId}`} target="_blank" state={{ clientActionId: element.clientActionId }}>
                <div
                  className="toDoElement"
                  key={index}
                  onClick={(e) => this.onClickTodo(element, e)}
                >
                  {/* for flag */}
                  {element.priority === 2 ? (
                    <div className="leftCircle"></div>
                  ) : null}

                  <div className="textWrap">
                    <div className="d-flex w-100">
                      <span className="text1 flex-1">
                        {/* for caseManagement Todos */}
                        {element.todoTypeId === 5
                          ? element?.caseCode +
                          " - " +
                          valueEllipsis(element.todoDescription, 20)
                          : <EllipsisTooltip
                            text={
                              element.todoDescription
                            }
                            maxLine={20}
                          ></EllipsisTooltip>
                          // this.TooltipWrapper(element.todoDescription)
                        }
                        {" "}
                        {/*for all other todos */}
                      </span>

                      {/* for action items */}
                      <span className="nextActionData">
                        {element.todoTypeId === 3 &&
                          `Next Action: ${element.nextAction}`}
                      </span>
                    </div>
                    {element?.isManual && (
                      <span
                        className="manualTodoIcon"
                        id={`manualTodoIcon_${element.todoUuid}`}
                      >
                        <ManualIcon />
                        <p className="tooltiptext">Manually Created</p>
                      </span>
                    )}
                    <div className="d-flex">
                      <span
                        className="text2"
                      // onClick={() => this.onClickTodo(element)}
                      >
                        {element?.clientId
                          ? `Company: ${element?.businessName}`
                          : "General"}
                      </span>
                    </div>
                    {(
                      <RoleAuthorizationCC
                        page={Pages.landingPage}
                        action={actionAuthorization.editMyTodos}
                      />
                    ) && (
                        <div className="update">
                          <span
                            className="text"
                            onClick={(event) =>
                              this.setIsOpen(event, element.todoUuid)
                            }
                          >
                            Update
                          </span>
                          <Dropdown
                            className="img"
                            toggle={(event: any) =>
                              this.setIsOpen(event, element.todoUuid)
                            }
                            isOpen={element.todoUuid === this.state.todoToggle}
                            onMouseLeave={() =>this.setState({ todoToggle: "-1" })}
                          >
                            <DropdownToggle>
                              <CombinedShape />
                            </DropdownToggle>
                            <DropdownMenu container="body" className="toDoListMenu">
                              {element?.isManual && (
                                <>
                                  {(
                                    <DropdownItem
                                      onClick={(e: any) => this.onClickTodo(element, e)}
                                    >
                                      View Details
                                    </DropdownItem>
                                  )}

                                  {element?.status === TodoStatus.Open && (
                                    <DropdownItem
                                      onClick={() =>
                                        this.handleStatusChange(
                                          element,
                                          TodoStatus.In_Progress
                                        )
                                      }
                                    >
                                      Move to In Progress
                                    </DropdownItem>
                                  )}
                                  {element.status == TodoStatus.Open &&
                                    element.todoTypeId !== 3 && (
                                      <DropdownItem
                                        onClick={() =>
                                          this.markTodoComplete(
                                            element,
                                            TodoStatus.Completed
                                          )
                                        }
                                      >
                                        Mark Complete
                                      </DropdownItem>
                                    )}
                                </>
                              )}
                              {!element?.isManual && (
                                <DropdownItem
                                  onClick={() => {
                                    this.toggle();
                                    this.setSelectedTodo(element);
                                  }}
                                >
                                  Assign
                                </DropdownItem>
                              )}
                              <DropdownItem
                                onClick={() => this.toggleTodoFlag(element)}
                              >
                                {element.priority === 2
                                  ? "Remove important flag"
                                  : "Flag as Important"}
                              </DropdownItem>
                              {element.status == TodoStatus.In_Progress &&
                                (element.todoTypeId !== 3 && element.todoTypeId !== 1) && (
                                  <DropdownItem
                                    onClick={() =>
                                      this.markTodoComplete(
                                        element,
                                        TodoStatus.Completed
                                      )
                                    }
                                  >
                                    Mark Complete
                                  </DropdownItem>
                                )}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      )}
                  </div>
                </div>
              </Link>) :
                (<div
                  className="toDoElement"
                  key={index}
                  onClick={(e) => this.onClickTodo(element, e)}
                >
                  {/* for flag */}
                  {element.priority === 2 ? (
                    <div className="leftCircle"></div>
                  ) : null}

                  <div className="textWrap">
                    <div className="d-flex w-100">
                      <span className="text1 flex-1">
                        {/* for caseManagement Todos */}
                        {element.todoTypeId === 5
                          ? element?.caseCode +
                          " - " +
                          valueEllipsis(element.todoDescription, 20)
                          :
                          <EllipsisTooltip
                            text={
                              element.todoDescription
                            }
                            maxLine={20}
                          ></EllipsisTooltip>
                          // this.TooltipWrapper(element.todoDescription)
                        }{" "}
                        {/*for all other todos */}
                      </span>

                      {/* for action items */}
                      <span className="nextActionData">
                        {element.todoTypeId === 3 &&
                          `Next Action: ${element.nextAction}`}
                      </span>
                    </div>
                    {element?.isManual && (
                      <span
                        className="manualTodoIcon"
                        id={`manualTodoIcon_${element.todoUuid}`}
                      >
                        <ManualIcon />
                        <p className="tooltiptext">Manually Created</p>
                      </span>
                    )}
                    <div className="d-flex">
                      <span
                        className="text2"
                      // onClick={() => this.onClickTodo(element)}
                      >
                        {element?.clientId
                          ? `Company: ${element?.businessName}`
                          : "General"}
                      </span>
                    </div>
                    {(
                      <RoleAuthorizationCC
                        page={Pages.landingPage}
                        action={actionAuthorization.editMyTodos}
                      />
                    ) && (
                        <div className="update">
                          <span
                            className="text"
                            onClick={(event) =>
                              this.setIsOpen(event, element.todoUuid)
                            }
                          >
                            Update
                          </span>
                          <Dropdown
                            className="img"
                            toggle={(event: any) =>
                              this.setIsOpen(event, element.todoUuid)
                            }
                            isOpen={element.todoUuid === this.state.todoToggle}
                            onMouseLeave={() =>this.setState({ todoToggle: "-1" })}
                          >
                            <DropdownToggle>
                              <CombinedShape />
                            </DropdownToggle>
                            <DropdownMenu container="body" className="toDoListMenu">
                              {element?.isManual && (
                                <>
                                  {(
                                    <DropdownItem
                                      onClick={(e: any) => this.onClickTodo(element, e)}
                                    >
                                      View Details
                                    </DropdownItem>
                                  )}

                                  {element?.status === TodoStatus.Open && (
                                    <DropdownItem
                                      onClick={() =>
                                        this.handleStatusChange(
                                          element,
                                          TodoStatus.In_Progress
                                        )
                                      }
                                    >
                                      Move to In Progress
                                    </DropdownItem>
                                  )}
                                  {element.status == TodoStatus.Open &&
                                    element.todoTypeId !== 3 && (
                                      <DropdownItem
                                        onClick={() =>
                                          this.markTodoComplete(
                                            element,
                                            TodoStatus.Completed
                                          )
                                        }
                                      >
                                        Mark Complete
                                      </DropdownItem>
                                    )}
                                </>
                              )}
                              {!element?.isManual && (
                                <DropdownItem
                                  onClick={() => {
                                    this.toggle();
                                    this.setSelectedTodo(element);
                                  }}
                                >
                                  Assign
                                </DropdownItem>
                              )}
                              <DropdownItem
                                onClick={() => this.toggleTodoFlag(element)}
                              >
                                {element.priority === 2
                                  ? "Remove important flag"
                                  : "Flag as Important"}
                              </DropdownItem>
                              {element.status == TodoStatus.In_Progress &&
                                element.todoTypeId !== 3 && (
                                  <DropdownItem
                                    onClick={() =>
                                      this.markTodoComplete(
                                        element,
                                        TodoStatus.Completed
                                      )
                                    }
                                  >
                                    Mark Complete
                                  </DropdownItem>
                                )}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      )}
                  </div>
                </div>)
            ))
        ) : (
          <>No Records Found</>
        )}
      </>
    );
  };

  render() {
    return (
      <div className="myTodo">
        <div className="header">
          <span className="headerText">My To Do’s</span>
          <div className="rightOptions">
            <input
              type="text"
              id="search"
              placeholder={`Search`}
              onChange={(e) => this.serachTodo(e)}
              value={this.state.todoSearch}
            />
            <Button onClick={this.createTodoToggle}>Create</Button>
          </div>
        </div>
        <div className="body">
          <Tab.Container id="left-tabs-example" defaultActiveKey="open">
            <Row>
              <Col sm={12} className="todoNav">
                <Nav variant="pills" id="toDoListNav" className="mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="open">
                      Open {"("}
                      {
                        (this.state.todoFilter && this.state.todoSearch
                          ? this.state.todoFilter
                          : this.state.todoData
                        )?.filter(
                          (each) =>
                            each.status !== TodoStatus.In_Progress &&
                            each.status !== TodoStatus.Completed
                        ).length
                      }
                      {")"}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="inProgress">
                      In Progress {"("}
                      {
                        (this.state.todoFilter && this.state.todoSearch
                          ? this.state.todoFilter
                          : this.state.todoData
                        )?.filter(
                          (each) => each.status === TodoStatus.In_Progress
                        ).length
                      }
                      {")"}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Tab.Content>
                  <Tab.Pane className="tabElement" eventKey="open" onScroll={() =>this.setState({ todoToggle: "-1" })}>
                    {this.getTodoElement(this.getTodoData("open") || [])}
                  </Tab.Pane>
                  <Tab.Pane className="tabElement" eventKey="inProgress" onScroll={() =>this.setState({ todoToggle: "-1" })}>
                    {this.getTodoElement(this.getTodoData("inProgress") || [])}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
          <div></div>
        </div>
        <Modal
          className="assignTodoModal"
          isOpen={this.state.assignTodoModal}
          fade={false}
          toggle={this.toggle}
        >
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <ModalBody>
            <AssignTodoForm
              toggle={this.toggle}
              getTodo={this.getTodo}
              todo={this.state.selectedTodo}
              updateTodo={this.updateTodo}
            // userId={this.context?.bankuserDetails?.userUuid}
            // role={this.context?.bankuserDetails?.roles[0]}
            />
          </ModalBody>
        </Modal>
        <Modal
          className="createTodoModal"
          isOpen={this.state.createTodoModal}
          fade={false}
          toggle={this.createTodoToggle}
        >
          <ModalHeader toggle={this.createTodoToggle}></ModalHeader>
          <ModalBody>
            <CreateTodoForm
              createTodoToggle={this.createTodoToggle}
              getTodo={this.getTodo}
              initialValues={{ todoType: 17 }}
            />
          </ModalBody>
        </Modal>
        {this.state.todoViewDetailsModal && this.state.selectedTodo && (
          <TodoViewDetails
            todoViewDetailsModal={this.state.todoViewDetailsModal}
            toggleViewDetails={this.toggleViewDetails}
            todoViewLoader={this.state.todoViewLoader}
            toggleTodoViewLoader={this.toggleTodoViewLoader}
            todoUuid={this.state.selectedTodo.todoUuid}
            selectedTodo={this.state.selectedTodo}
            todoFlagged={this.todoFlagged}
            handleStatusChange={this.handleStatusChange}
            reloadComponent={this.state.reloadComponent}
            getTodo={this.getTodo}
          />
        )}
      </div>
    );
  }
}

export default withRouter<WithRouterProps<ITodoRCProps>>(TodoRC);
